import * as React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import ArrowProgressBar from "./arrow_bar_stepper";
import { FINAL_VERIFICATION_ACTIONS } from "../../enum/final_verification_actions";
import { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CommissioningUserAgreement from "./commissioning_user_agreement";
import ReviewTimelineCard from "./commissioning_review_timeline";
import { TOOLTIPS_EN } from "../../../../../../../enums/tooltip_enum_EN";
import { enqueueSnackbar } from "notistack";
import Snackbar from "../../../../../../../scripts/snackbar";

export const DeviceControlComponent = ({
  isAdmin,
  isStart,
  isUAAccepted,
  isLocked,
  userNotAllowedToUpdate,
  mutation,
  isMutating,
  step,
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  const signUAText = (
    <>
      {
        <Box>
          {isUAAccepted ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon fontSize="xs" style={{ color: "green" }} />
              <p style={{ marginLeft: 8, marginBottom: 0 }}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenDialog(true);
                  }}
                  style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                >
                  User agreement
                </a>
                &nbsp;accepted by {step.ua_accepted_by}.
              </p>
            </Box>
          ) : (
            <p>
              Click{" "}
              <a
                href="#"
                onClick={(e) => {
                  if (!isLocked) {
                    e.preventDefault();
                    setOpenDialog(true);
                  } else {
                    Snackbar.error("Please finish other phases before proceeding");
                  }
                }}
                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
              >
                here
              </a>{" "}
              to accept the commissioning user agreement.
            </p>
          )}

          <CommissioningUserAgreement
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            alreadyAccepted={isUAAccepted}
            onAgree={(value) =>
              mutation({
                item_id: step.step_id,
                item_value: value,
                action: FINAL_VERIFICATION_ACTIONS.ACCEPT_USER_AGREEMENT,
              })
            }
          />
        </Box>
      }
    </>
  );

  const startDate = isStart ? new Date() : new Date(step.valid_from_utc * 1000);
  let endDate = isStart ? new Date(startDate) : new Date(step.valid_to_utc * 1000);
  if (isStart) {
    endDate.setDate(endDate.getDate() + 1);
  }

  const controlStages = [
    {
      item_id: 1,
      item_label: isStart ? "Estimated start" : "Start",
      item_value: startDate.toLocaleString(),
      is_ongoing: false,
    },
    {
      item_id: 2,
      item_label: "1 day - full power control",
      is_ongoing: isStart ? false : endDate >= new Date(),
    },
    {
      item_id: 3,
      item_label: isStart ? "Estimated end" : "Expected end",
      item_value: endDate.toLocaleString(),
      is_ongoing: isStart ? false : endDate < new Date(),
    },
  ];

  if (!controlStages || controlStages.length === 0) {
    return null;
  }
  return (
    <div style={{ marginTop: 10 }}>
      <ArrowProgressBar controlStages={controlStages} />
      {isStart && Array.isArray(step.changelog) && step.changelog.length > 0 ? (
        <div style={{ marginTop: 10 }}>
          <ReviewTimelineCard tooltip={TOOLTIPS_EN.COMMISSIONING_DENIED_CARD} changelog={step.changelog} />
        </div>
      ) : null}
      {isStart && !isMutating ? (
        <Box display="flex" justifyContent="center" sx={{ mb: 2, mt: 5 }}>
          {signUAText}
        </Box>
      ) : null}
      {isMutating ? (
        <Box display="flex" justifyContent="center" sx={{ mb: 2, mt: 5 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" sx={{ mb: 2, mt: 5, gap: "8px" }}>
          <Button
            variant="outlined"
            color="inherit"
            size="small"
            disabled={isLocked || userNotAllowedToUpdate || !isUAAccepted}
            onClick={() => {
              if (isStart) {
                mutation({
                  item_id: step.step_id,
                  item_value: isStart,
                  action: FINAL_VERIFICATION_ACTIONS.START_CONTROL,
                });
              } else {
                const confirmed = window.confirm(
                  "You're about to reset the control phase early. Are you sure you want to proceed?",
                );
                if (confirmed) {
                  mutation({
                    item_id: step.step_id,
                    item_value: isStart,
                    action: FINAL_VERIFICATION_ACTIONS.RESET_CONTROL,
                  });
                }
              }
            }}
            sx={{ borderRadius: 2 }}
            disableElevation
          >
            {isStart ? "Start device control" : "Reset device control phase"}
          </Button>
          {!isStart && isAdmin && (
            <Button
              variant="outlined"
              color="inherit"
              size="small"
              disabled={isLocked || userNotAllowedToUpdate}
              onClick={() => {
                const confirmed = window.confirm(
                  "You're about to complete the control phase early. Are you sure you want to proceed?",
                );
                if (confirmed) {
                  mutation({
                    item_id: step.step_id,
                    item_value: true,
                    action: FINAL_VERIFICATION_ACTIONS.COMPLETE_CONTROL,
                  });
                }
              }}
              sx={{ borderRadius: 2 }}
              disableElevation
            >
              {"complete device control"}
            </Button>
          )}
        </Box>
      )}
    </div>
  );
};
